var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtiquetaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 9.39062C19.7969 9.79688 19.9844 10.2812 19.9844 10.8438C19.9844 11.375 19.7969 11.8438 19.4219 12.25L12.25 19.4219C11.875 19.7969 11.4062 19.9844 10.8438 19.9844C10.2812 19.9844 9.8125 19.7969 9.4375 19.4219L0.578125 10.5625C0.203125 10.1875 0.015625 9.71875 0.015625 9.15625V1.98438C0.015625 1.45312 0.203125 1 0.578125 0.625C0.984375 0.21875 1.45312 0.015625 1.98438 0.015625H9.15625C9.71875 0.015625 10.1875 0.203125 10.5625 0.578125L19.4219 9.39062ZM4.51562 6.01562C4.92188 6.01562 5.26562 5.875 5.54688 5.59375C5.85938 5.28125 6.01562 4.92188 6.01562 4.51562C6.01562 4.07812 5.85938 3.71875 5.54688 3.4375C5.26562 3.15625 4.92188 3.01562 4.51562 3.01562C4.07812 3.01562 3.71875 3.15625 3.4375 3.4375C3.15625 3.71875 3.01562 4.07812 3.01562 4.51562C3.01562 4.92188 3.15625 5.28125 3.4375 5.59375C3.71875 5.875 4.07812 6.01562 4.51562 6.01562Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtiquetaIcon);
export default __webpack_public_path__ + "static/media/etiqueta_icon.898a7181082128288b4897d5acaf9f45.svg";
export { ForwardRef as ReactComponent };